import { Drawer, Grid } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import drillXLogo from 'assets/drillx.png';
import Button from 'components/Button';
import TotalLogo from 'components/TotalLogo';
import { useIntl } from 'react-intl';

import styles from './Sidebar.module.scss';
import { useSidebar } from './useSidebar';

type Props = {
  isOpen: boolean;
  onSidebarChanged: () => void;
};

const Sidebar = ({ isOpen, onSidebarChanged }: Props) => {
  const intl = useIntl();
  const { getStylePerState, isOpenDelayed, getSideBarComponentToRender } = useSidebar({
    isOpen,
    onSidebarChanged,
  });

  return (
    <>
      <Drawer
        variant="permanent"
        className={getStylePerState(styles.drawerContainer)}
        anchor="left"
        open={isOpen}
        PaperProps={{
          className: getStylePerState(styles.sidebarPaper),
        }}
      >
        {(isOpen || isOpenDelayed) && (
          <>
            <Grid container item className={styles.logoContainer}>
              <TotalLogo className={styles.totalLogo} />
              <Grid className={styles.menuLabel}>
                <img className={styles.drillxLogo} alt="DrillX logo" src={drillXLogo} />
                <p className={styles.logoText}>
                  {intl.formatMessage({ id: 'sidebar.smart' })}{' '}
                  <span className={styles.logoTextOperations}>
                    {intl.formatMessage({ id: 'sidebar.operations' })}
                  </span>
                </p>
              </Grid>
            </Grid>

            {getSideBarComponentToRender()}
          </>
        )}
      </Drawer>
      <Button className={getStylePerState(styles.toggleDrawerButton)} onClick={onSidebarChanged}>
        <ChevronLeftIcon classes={{ root: getStylePerState(styles.buttonArrow) }} />
      </Button>
    </>
  );
};

export default Sidebar;
